import React from "react";
import "./StudentTable.css";

const StudentTable = ({
  data,
  columns,
  selectedRows = [],
  onSelectAll,
  onSelectRow,
  showRowSelector = false,
  onRowClick,
}) => {
  const renderCell = (row, column) => {
    if (
      column.key === "certificateLink" ||
      column.key === "reportLink" ||
      column.key === "deepLink"
    ) {
      const value = row[column.key];
      if (!value) return "";
      return (
        <a
          href={value}
          target="_blank"
          rel="noopener noreferrer"
          className="table-link"
        >
          {column.key === "certificateLink"
            ? "View Certificate"
            : column.key === "reportLink"
            ? "View Report"
            : "View Exam"}
        </a>
      );
    }
    if (column.key === "viewStudents") {
      return (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onRowClick(row, "viewStudents");
          }}
          className="table-link"
        >
          View Students ↗
        </a>
      );
    }
    return row[column.key];
  };

  return (
    <div className="table-container">
      <table>
        <thead>
          <tr>
            {showRowSelector && (
              <th>
                <input
                  type="checkbox"
                  onChange={onSelectAll}
                  checked={
                    data.length > 0 && selectedRows.length === data.length
                  }
                />
              </th>
            )}
            {columns.map((column) => (
              <th key={column.key}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr
              key={row._id || row.id || `row-${index}`}
              onClick={() => onRowClick && onRowClick(row)}
              style={{ cursor: onRowClick ? "pointer" : "default" }}
            >
              {showRowSelector && (
                <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(row.loginId)}
                    onChange={() => onSelectRow(row.loginId)}
                  />
                </td>
              )}
              {columns.map((column) => (
                <td key={`${row.id}-${column.key}`}>
                  {renderCell(row, column)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StudentTable;
